<template>
  <v-data-table
    :headers="removeRepairItemDataTableHeaders"
    :items="computedRepairItems"
    class="elevation-1 my-5 mx-5"
    :search="searchRepairItems"
    :loading-text="$t('common_get_data')"
    :no-data-text="$t('common_no_data')"
    :no-results-text="$t('common_no_results')"
    :footer-props="{
      'items-per-page-options': [30, 50, 100],
      'items-per-page-text': $t('item_rows_per_page'),
    }"
    :header-props="headerProps"
    item-key="Index"
    show-select
    v-model="selectNeedThrowItem"
    :item-class="isOutOfWarrantyClass"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t(titleName) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchRepairItems"
          append-icon="mdi-magnify"
          :label="$t('quotation_item_new_install_search')"
          single-line
          hide-details
          clearable
        ></v-text-field>
        <!-- <v-btn
          color="primary"
          dark
          class="mb-2 ml-8"
          @click="openEditedRepair"
          :disabled="isAllTextFieldDisable || isDone"
        >
          {{ $t('common_new') }}
        </v-btn> -->
        <v-btn
          color="primary"
          dark
          class="mb-2 ml-8"
          :disabled="isAllTextFieldDisable || !isDone || isAcceptance"
          @click="setItemIsNeedThrowResume"
        >
          確定拋轉的品項
        </v-btn>
        <v-dialog v-model="isShowEditRepairItemDialog" persistent>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ repairItemDialogTitle }}</span>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <v-container>
                <ValidationObserver ref="repairItem">
                  <v-row>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.Number"
                        :label="$t('quotation_item_number')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.Name"
                        :label="$t('quotation_item_name')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.Unit"
                        :label="$t('quotation_item_unit')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-checkbox
                        v-model="editedRepairItem.RemoveItem.IsNeedThrowResume"
                        label="確定轉拋履歷卡"
                        :disabled="isAcceptance"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.Quantity"
                        :label="$t('quotation_item_quantity')"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.RealQuantity"
                        :label="$t('installation_acceptance_item_real_quantity')"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.OriginalSerialNumber"
                        :label="$t('engineer_item_original_serial_numbers')"
                        disabled
                        v-if="editedRepairItem.RemoveItem.SerialNumber"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.SerialNumber.Number"
                        :label="$t('quotation_item_serialnumber')"
                        disabled
                        v-if="editedRepairItem.RemoveItem.SerialNumber"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <ValidationProvider
                        :name="$t('installation_notice_item_buy_or_rent')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-autocomplete
                          v-model="editedRepairItem.RemoveItem.BuyOrRentType"
                          :items="allBuyOrRentType"
                          item-text="Name"
                          item-value="Type"
                          required
                          :loading-text="$t('common_get_data')"
                          :no-data-text="$t('common_no_results')"
                          :error-messages="errors[0]"
                          @change="setBuyOrRentType"
                          @keyup.enter="setRemoveBuyOrRentTypeAutocomplete"
                          ref="removeBuyOrRentTypeAutocomplete"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_notice_item_buy_or_rent') }}
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-autocomplete
                        v-model="editedRepairItem.RemoveItem.InstallPosition"
                        :items="allInstallPositionType"
                        item-text="Name"
                        item-value="Type"
                        :label="$t('quotation_item_install_position')"
                        small-chips
                        multiple
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        disabled
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-autocomplete
                        v-model="editedRepairItem.RemoveItem.Custody"
                        :items="allCustodyType"
                        item-text="Name"
                        item-value="Type"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        @keyup.enter="setCustodyAutocomplete"
                        ref="custodyTypeAutocomplete"
                        disabled
                        :label="$t('resume_item_custody')"
                      >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-checkbox
                        v-model="editedRepairItem.RemoveItem.IsPersonalFactor"
                        label="人為"
                        disabled
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-checkbox
                        v-model="editedRepairItem.RemoveItem.IsCustomerDevice"
                        :label="$t('quotation_item_is_customer_device')"
                        :disabled="editedRepairItem.RemoveItem.BuyOrRentType === 1"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                      <v-autocomplete
                        v-model="editedRepairItem.RemoveItem.CustomerDeviceType"
                        :items="computedCustomerDeviceTypeList"
                        item-text="Name"
                        item-value="Type"
                        :label="$t('engineer_item_customer_device_type')"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-if="editedRepairItem.RemoveItem.IsCustomerDevice"
                        :disabled="isAcceptance"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedRepairItem.RemoveItem.HasAuthorize">
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-autocomplete
                        :items="gmTypeList"
                        item-text="Name"
                        item-value="Type"
                        :loading-text="$t('common_get_data')"
                        :no-data-text="$t('common_no_results')"
                        v-model="editedRepairItem.RemoveItem.GmServerType"
                        label="GM"
                        :disabled="isAcceptance || editedRepairItem.IsDone"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" xl="3" lg="3">
                      <v-text-field
                        v-model="editedRepairItem.RemoveItem.AuthorizeItemSerialNumber"
                        label="授權序號"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedRepairItem.Reason">
                    <v-col>
                      <ValidationProvider
                        :name="$t('installation_acceptance_item_reason')"
                        rules="required"
                        v-slot="{ errors }"
                        v-if="
                          editedRepairItem.RemoveItem.Quantity * 1 !==
                            editedRepairItem.RemoveItem.RealQuantity * 1
                        "
                      >
                        <v-textarea
                          outlined
                          v-model="editedRepairItem.Reason"
                          :error-messages="errors[0]"
                          :disabled="isAcceptance || editedRepairItem.IsDone"
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            {{ $t('installation_acceptance_item_reason') }}
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                      <ValidationProvider
                        name="換GM Server原因"
                        rules="required"
                        v-slot="{ errors }"
                        v-else
                      >
                        <v-textarea
                          outlined
                          v-model="editedRepairItem.Reason"
                          :error-messages="errors[0]"
                          disabled
                        >
                          <template v-slot:label>
                            <span class="red--text">
                              <strong>* </strong>
                            </span>
                            換GM Server原因
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </ValidationObserver>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeEditRepairItem">
                {{ $t('common_cancel') }}
              </v-btn>
              <v-btn color="green darken-1" text @click="addRepairItem">
                {{ $t('common_confirm') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <delete-dialog
          :isAllTextFieldDisable="false"
          :isLoadingSaveBtn="false"
          :isShowDeleteDialog="isShowDeleteRepairItemDialog"
          :deleteMessage="'installation_acceptance_item_delete_dialog_message'"
          @closeDelete="closeDeleteRepairItem"
          @confirmDelete="confirmDeleteRepairItem"
        />
      </v-toolbar>
    </template>
    <template v-slot:[`header.data-table-select`] v-if="isAcceptance"></template>
    <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
      <v-simple-checkbox
        :ripple="false"
        :value="isSelected"
        :readonly="isAcceptance"
        :disabled="isAcceptance"
        @input="select($event)"
      ></v-simple-checkbox>
    </template>
    <template v-slot:[`item.Edit`]="{ item }">
      <v-btn
        icon
        @click="isShowEditRepairItemDialogBtn(item)"
        :disabled="isAllTextFieldDisable || isAcceptance"
      >
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn
        icon
        @click="isShowDeleteRepairItemDialogBtn(item)"
        :disabled="isAllTextFieldDisable || isDone"
      >
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:[`item.RemoveItem.InstallPosition`]="{ item }">
      {{ turnData(item.RemoveItem.InstallPosition) }}
    </template>
    <template v-slot:[`item.RemoveItem.BuyOrRentType`]="{ item }">
      {{ turnBuyOrRentType(item.RemoveItem.BuyOrRentType) }}
    </template>
    <template v-slot:[`item.RemoveItem.Custody`]="{ item }">
      {{ turnCustodyData(item.RemoveItem.Custody) }}
    </template>
  </v-data-table>
</template>

<script>
import { BuyOrRentType } from '@/js/BuyOrRentType'
import { CustodyType } from '@/js/CustodyType'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import {
  HttpInstallationAcceptance,
  HttpQuotation,
  HttpInstallPosition,
  HttpFix,
  HttpAuthorizeMapping
} from '@/js/http-Manager'
import DeleteDialog from '@/components/DeleteDialog.vue'
export default {
  components: { DeleteDialog },
  name: 'RepairItemRemoveNotInResume',
  props: {
    repairItemsNotInResume: {
      type: Array,
      default () {
        return []
      }
    },
    isDone: {
      type: Boolean,
      default: false
    },
    isAcceptance: {
      type: Boolean,
      default: false
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    titleName: {
      type: String
    }
  },
  data: () => ({
    gmTypeList: [],
    searchRepairItems: '',
    isShowEditRepairItemDialog: false,
    isShowDeleteRepairItemDialog: false,
    allBuyOrRentType: [],
    customerDeviceTypeList: [],
    allInstallPositionType: [],
    editedRepairItemIndex: -1,
    editedRepairItem: {
      RemoveItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false,
        CustomerDeviceType: 0
      },
      ReturnItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2,
        CustomerDeviceType: 0
      },
      Reason: ''
    },
    defaultRepairItem: {
      RemoveItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        OriginalSerialNumber: '',
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 1,
        IsPersonalFactor: false,
        CustomerDeviceType: 0
      },
      ReturnItem: {
        ItemId: '',
        Number: '',
        Name: '',
        Unit: '',
        Quantity: 0,
        RealQuantity: 0,
        BuyOrRentType: 0,
        SerialNumber: {
          ItemId: '',
          Number: '',
          IsUsed: false,
          AcceptanceNumber: '',
          RepairNumber: ''
        },
        WarrantyPeriod: 0,
        IsCustomerDevice: false,
        InstallPosition: 0,
        HasSerialNumber: false,
        WorkType: 2,
        CustomerDeviceType: 0
      },
      Reason: ''
    },
    selectNeedThrowItem: [],
    allCustodyType: []
  }),
  async mounted () {
    await this.getBuyOrRentType()
    await this.getAllInstallPositionType()
    await this.getCustomerDeviceType()
    await this.getAllCustodyType()
    await this.getGmTypeList()
    if (this.repairItemsNotInResume.length > 0) {
      this.selectNeedThrowItem = this.computedRepairItems.filter(
        (x) => x.RemoveItem.IsNeedThrowResume
      )
    }
  },
  watch: {
    repairItemsNotInResume (val) {
      if (val.length > 0) {
        this.selectNeedThrowItem = this.computedRepairItems.filter(
          (x) => x.RemoveItem.IsNeedThrowResume
        )
      }
    }
  },
  computed: {
    computedRepairItems () {
      let array = []
      this.repairItemsNotInResume.forEach((element, index) => {
        array.push(
          Object.assign(
            {
              Index: index
            },
            element
          )
        )
      })
      return array
    },
    repairItemDialogTitle () {
      return this.editedRepairItemIndex === -1
        ? this.$t('installation_acceptance_item_add')
        : this.$t('installation_acceptance_item_edit')
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    removeRepairItemDataTableHeaders () {
      return [
        {
          text: this.$t('installation_notice_item_main_name'),
          align: 'start',
          value: 'RemoveItem.BomName'
        },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'RemoveItem.Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'RemoveItem.Name' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'RemoveItem.Unit' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'RemoveItem.Quantity' },
        {
          text: this.$t('installation_acceptance_item_real_quantity'),
          align: 'end',
          value: 'RemoveItem.RealQuantity'
        },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'start',
          value: 'RemoveItem.BuyOrRentType'
        },
        {
          text: this.$t('engineer_item_original_serial_numbers'),
          align: 'start',
          value: 'RemoveItem.OriginalSerialNumber'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'RemoveItem.SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'RemoveItem.IsCustomerDevice'
        },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'RemoveItem.InstallPosition'
        },
        {
          text: this.$t('resume_item_custody'),
          align: 'start',
          value: 'RemoveItem.Custody'
        },
        {
          text: '要拋轉?',
          align: 'start',
          value: 'RemoveItem.IsNeedThrowResume',
          sortable: false
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    computedCustomerDeviceTypeList () {
      let array = []
      if (this.editedRepairItem.RemoveItem.Number.includes('RA400')) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedRepairItem.RemoveItem.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    }
  },
  methods: {
    async getGmTypeList () {
      let response = await HttpAuthorizeMapping.GetGmTypes()
      this.gmTypeList = response.status === 200 ? response.data.Data : []
    },
    async getAllCustodyType () {
      let response = await HttpFix.GetCustodyType()
      this.allCustodyType = response.status === 200 ? response.data.Data : []
    },
    turnCustodyData (val) {
      return CustodyType.CustodyTypeName(val)
    },
    isOutOfWarrantyClass (item) {
      if (item.RemoveItem.IsOutOfWarranty && item.RemoveItem.BuyOrRentType === 1) {
        return 'red'
      }
      if (item.RemoveItem.IsPersonalFactor) {
        return 'yellow'
      }
    },
    setItemIsNeedThrowResume () {
      let temp = this.computedRepairItems
      this.selectNeedThrowItem.forEach((element) => {
        let index = temp.indexOf(element)
        temp.splice(index, 1)
      })
      this.$emit('setItemIsNeedThrowResume', temp)
      this.selectNeedThrowItem = []
    },
    setRemoveBuyOrRentTypeAutocomplete (event) {
      this.$refs.removeBuyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.removeBuyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (form[i].type !== 'hidden' && !form[i].disabled && form[i].type !== 'checkbox') {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    setBuyOrRentType () {
      if (this.editedRepairItem.RemoveItem.BuyOrRentType === 1) {
        this.editedRepairItem.RemoveItem.IsCustomerDevice = true
        this.editedRepairItem.RemoveItem.CustomerDeviceType = 3
      }
      // this.editedRepairItem = JSON.parse(JSON.stringify(this.editedRepairItem))
    },
    openEditedRepair () {
      this.isShowEditRepairItemDialog = true
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.allInstallPositionType
        )
      }
    },
    async isShowEditRepairItemDialogBtn (item) {
      this.editedRepairItemIndex = this.computedRepairItems.indexOf(item)
      this.editedRepairItem = JSON.parse(JSON.stringify(item))
      this.isShowEditRepairItemDialog = true
    },
    isShowDeleteRepairItemDialogBtn (item) {
      this.editedRepairItemIndex = this.computedRepairItems.indexOf(item)
      let str = JSON.stringify(item)
      this.editedRepairItem = JSON.parse(str)
      this.isShowDeleteRepairItemDialog = true
    },

    confirmDeleteRepairItem () {
      this.$emit('setDeleteItem', this.editedRepairItemIndex)
      this.closeDeleteRepairItem()
    },

    closeEditRepairItem () {
      this.isShowEditRepairItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultRepairItem)
        this.editedRepairItem = JSON.parse(str)
        this.editedRepairItemIndex = -1
      })
    },

    closeDeleteRepairItem () {
      this.isShowDeleteRepairItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultRepairItem)
        this.editedRepairItem = JSON.parse(str)
        this.editedRepairItemIndex = -1
      })
    },
    async addRepairItem () {
      const isValid = await this.$refs.repairItem.validate()
      if (isValid) {
        this.$emit('setEditedRepairItemIndex', this.editedRepairItemIndex)
        this.$emit('setEditedRemoveRepairItemNotInResume', this.editedRepairItem)
        this.closeEditRepairItem()
      }
    }
  }
}
</script>
